import {
  RichTextEditorProps,
  RichTextViewer as RichTextViewerComponent,
  RichTextViewerProps,
  RichTextEditor as RichTextEditorComponent,
} from "widgets";

export function RichTextViewer(props: Omit<RichTextViewerProps, "fontMap">) {
  return (
    <RichTextViewerComponent
      fontMap={{
        "Inter-Regular": require("../assets/Inter/Inter-Regular.ttf"),
        "Inter-Bold": require("../assets/Inter/Inter-Bold.ttf"),
        "Inter-Italic": require("../assets/Inter/Inter-Italic.ttf"),
        "Inter-SemiBoldItalic": require("../assets/Inter/Inter-SemiBoldItalic.ttf"),
      }}
      {...props}
    />
  );
}

export function RichTextEditor(props: Omit<RichTextEditorProps, "fontMap">) {
  return (
    <RichTextEditorComponent
      fontMap={{
        "Inter-Regular": require("../assets/Inter/Inter-Regular.ttf"),
        "Inter-Bold": require("../assets/Inter/Inter-Bold.ttf"),
        "Inter-Italic": require("../assets/Inter/Inter-Italic.ttf"),
        "Inter-SemiBoldItalic": require("../assets/Inter/Inter-SemiBoldItalic.ttf"),
      }}
      {...props}
    />
  );
}
